const allQuestions = [
  // Day 1 equivalent
  { id: 1, question: "What is the capital of India?", options: ["New Delhi", "Mumbai", "Kolkata", "Chennai"], correctAnswer: "New Delhi" },
  { id: 2, question: "Which goes faster?", options: ["Light", "Sound", "Wind", "Water"], correctAnswer: "Light" },
  { id: 3, question: "How many days are in a leap year?", options: ["364", "365", "366", "367"], correctAnswer: "366" },
  { id: 4, question: "Which animal is known as the Ship of the Desert?", options: ["Horse", "Camel", "Elephant", "Donkey"], correctAnswer: "Camel" },
  { id: 5, question: "What is 15 + 25?", options: ["30", "40", "45", "50"], correctAnswer: "40" },
  { id: 6, question: "How many colors are in a rainbow?", options: ["5", "6", "7", "8"], correctAnswer: "7" },
  { id: 7, question: "Which is the largest planet in our solar system?", options: ["Earth", "Mars", "Jupiter", "Saturn"], correctAnswer: "Jupiter" },
  { id: 8, question: "What do bees produce?", options: ["Milk", "Honey", "Wax", "Both Honey and Wax"], correctAnswer: "Both Honey and Wax" },
  { id: 9, question: "Which shape has 3 sides?", options: ["Square", "Circle", "Triangle", "Rectangle"], correctAnswer: "Triangle" },
  { id: 10, question: "What is the freezing point of water?", options: ["0°C", "10°C", "100°C", "-10°C"], correctAnswer: "0°C" },

  // Day 2 equivalent
  { id: 11, question: "Who was the first Prime Minister of India?", options: ["Gandhi", "Nehru", "Bose", "Patel"], correctAnswer: "Nehru" },
  { id: 12, question: "What is the National Bird of India?", options: ["Parrot", "Peacock", "Pigeon", "Eagle"], correctAnswer: "Peacock" },
  { id: 13, question: "Which festival is known as the Festival of Lights?", options: ["Holi", "Diwali", "Eid", "Christmas"], correctAnswer: "Diwali" },
  { id: 14, question: "How many months have 31 days?", options: ["5", "6", "7", "8"], correctAnswer: "7" },
  { id: 15, question: "What is the square root of 64?", options: ["6", "7", "8", "9"], correctAnswer: "8" },
  { id: 16, question: "Who wrote the national anthem of India?", options: ["Tagore", "Bankim Chandra", "Sarojini Naidu", "Premchand"], correctAnswer: "Tagore" },
  { id: 17, question: "Which is the smallest continent?", options: ["Asia", "Australia", "Europe", "Africa"], correctAnswer: "Australia" },
  { id: 18, question: "How many hours are in 2 days?", options: ["24", "48", "72", "36"], correctAnswer: "48" },
  { id: 19, question: "Which gas do humans breathe out?", options: ["Oxygen", "Nitrogen", "Carbon Dioxide", "Helium"], correctAnswer: "Carbon Dioxide" },
  { id: 20, question: "How many legs does a spider have?", options: ["6", "8", "10", "12"], correctAnswer: "8" },

  // Day 3 equivalent
  { id: 21, question: "Which planet is known as the Red Planet?", options: ["Venus", "Mars", "Jupiter", "Saturn"], correctAnswer: "Mars" },
  { id: 22, question: "What is the largest ocean on Earth?", options: ["Atlantic", "Indian", "Arctic", "Pacific"], correctAnswer: "Pacific" },
  { id: 23, question: "Who invented the telephone?", options: ["Edison", "Newton", "Bell", "Einstein"], correctAnswer: "Bell" },
  { id: 24, question: "How many players are in a cricket team?", options: ["9", "10", "11", "12"], correctAnswer: "11" },
  { id: 25, question: "What is the capital of Australia?", options: ["Sydney", "Melbourne", "Canberra", "Perth"], correctAnswer: "Canberra" },
  { id: 26, question: "What is 5 multiplied by 8?", options: ["35", "40", "45", "50"], correctAnswer: "40" },
  { id: 27, question: "Which organ pumps blood in the human body?", options: ["Brain", "Lungs", "Heart", "Kidney"], correctAnswer: "Heart" },
  { id: 28, question: "What is the hardest natural substance on Earth?", options: ["Gold", "Iron", "Diamond", "Platinum"], correctAnswer: "Diamond" },
  { id: 29, question: "Which is the longest river in the world?", options: ["Amazon", "Nile", "Ganga", "Yangtze"], correctAnswer: "Nile" },
  { id: 30, question: "What is the boiling point of water?", options: ["50°C", "90°C", "100°C", "120°C"], correctAnswer: "100°C" },
];

export const getDailyQuestions = () => {
  const today = new Date();
  
  // Calculate day of the year (0 to 365)
  const start = new Date(today.getFullYear(), 0, 0);
  const diff = today - start;
  const oneDay = 1000 * 60 * 60 * 24;
  const dayOfYear = Math.floor(diff / oneDay);
  
  // Pick a set of 10 questions based on the day.
  // Example: day 1 -> idx 0, day 2 -> idx 10, day 3 -> idx 20, etc.
  // Rotate around array if day goes beyond available questions
  const totalSets = Math.floor(allQuestions.length / 10);
  
  // E.g., if totalSets = 3, dayOfYear % 3 will result in 0, 1, or 2
  const setIndex = dayOfYear % totalSets;
  
  const startIndex = setIndex * 10;
  
  return allQuestions.slice(startIndex, startIndex + 10);
};

export default allQuestions;
